module.exports = __webpack_public_path__ + "static/media/img1.11850804.jpg";